export default __webpack_public_path__ + "static/hello2-02502c9be470107ae8c63457809cbbf0.mp4";